import {
  POLLING_REQUEST_FAIL,
  DOWNPAYMENT_FAIL,
  INITIATE_DOWNPAYMENT,
  DOWNPAYMENT_SUCCESS,
  POLLING_ORDER_STATUS_SUCCESS
  // SET_ORDER_ID
} from "../../../constants";

const initialState = {
  isSubmitting: false, // Submitting custoner to api to charge down payment
  apiErrorMessage: null,
  orderStatus: null
  // apiErrorMessage: "payment failed"
};

export default function reducer(state = initialState, action) {
  // export default function reducer(state = {}, action) {
  switch (action.type) {
    case INITIATE_DOWNPAYMENT: {
      return { ...state, isSubmitting: true };
    }
    case POLLING_REQUEST_FAIL: {
      return { ...state, isSubmitting: false, apiErrorMessage: action.payload };
    }
    case POLLING_ORDER_STATUS_SUCCESS: {
      return { ...state, orderStatus: action.payload };
    }
    case DOWNPAYMENT_SUCCESS: {
      return { ...state, isSubmitting: false };
    }
    // case SET_ORDER_ID: {
    //   return { ...state, trips: orderId: action.payload };
    // }
    case DOWNPAYMENT_FAIL: {
      return { ...state, isSubmitting: false, apiErrorMessage: action.payload };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/scenes/ReviewOrder/CustomerInfoForm/reducer.js